import React, { createContext, useContext, useReducer } from "react";
import { initialState, conselhosReducer, ConselhosState } from "./conselhos-reducer";

type ConselhosContextType = {
    state: ConselhosState;
    dispatch: React.Dispatch<any>;
};

const ConselhosContext = createContext<ConselhosContextType | undefined>(undefined);

export const ConselhosProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(conselhosReducer, initialState);

    return (
        <ConselhosContext.Provider value={{ state, dispatch }}>
            {children}
        </ConselhosContext.Provider>
    );
};

export const useConselhosState = () => {
    const context = useContext(ConselhosContext);
    if (!context) {
        throw new Error("useConselhosState must be used within ConselhosProvider");
    }
    return context.state;
};

export const useConselhosDispatch = () => {
    const context = useContext(ConselhosContext);
    if (!context) {
        throw new Error("useConselhosDispatch must be used within ConselhosProvider");
    }
    return context.dispatch;
};
